import { userDetailsReducerKey } from './UserDetailsConstants';

export function userDetails(state) {
  return state.get(userDetailsReducerKey);
}

export function userSettings(state) {
  return userDetails(state).get('settings');
}

export function license(state) {
  return userDetails(state).get('license');
}

export function chemquoteEnabled(state) {
  return userDetails(state).getIn(['settings', 'chemquoteEnabled']);
}

export function pendoResourceCenterEnabled(state) {
  return userDetails(state).getIn(['settings', 'pendoResourceCenterEnabled']) || false;
}
